import { useState, useEffect, useRef } from "react";
import {
  Button,
  Form,
  Input,
  Row,
  Col,
  Select,
  DatePicker,
} from "antd";

import {
  Messages,
  Notify,
  openNotification,
  progressIndicatorEnum,
  util
} from '@seims/shared';

import dayjs from "dayjs";

import lookupAPI from "../../services/candidateLookupService";
import api from "../../services/nysService";
import { getProfile } from "@seims/shared/src/security";
import { recordError } from "../../utils/logService";

const Qualification = ({ onProgressUpdate, data, readOnly }) => {
  const [userData, setUserData] = useState(getProfile());
  const [qualifications, setQualifications] = useState([]);
  const [qualificationData, setQualificationData] = useState({});
  const [year, setYear] = useState(null);

  const formItemLayout = {
    labelCol: {
      span: 12,
    },
    wrapperCol: {
      span: 18,
    },
    layout: "vertical",
  };

  const { Option } = Select;
  const [form] = Form.useForm();
  const formName = "QualificationForm";

  const highestQualificationRef = useRef(null);
  const fieldOfStudyRef = useRef(null);
  const institutionOfStudyRef = useRef(null);
  const subject1Ref = useRef(null);
  const grade12CompletionYearRef = useRef(null);

  useEffect(() => {
    getQualifications();

  }, []);

  useEffect(() => {
    prePopilateQualifs();
  }, [qualifications, qualificationData, data]);

  const onNameBlur = (e) => {
    const { value, name } = e.target;
    const textValue = util.toPascalText(value);
    form.setFieldsValue({ [name]: textValue });
  };

  const prePopilateQualifs = () => {
    try {

      const selectedYear = data?.grade12CompletionYear
        ? dayjs(data.grade12CompletionYear.toString() || "", "YYYY")
        : null;

      if (!util.isEmpty(data)) {

        const selectedQualification = qualifications.find(
          (record) => record.key === data.highestQualification
        );

        form.setFieldsValue({
          id: data.id,
          fieldOfStudy: data.fieldOfStudy,
          highestQualification: selectedQualification,
          institutionOfStudy: data.institutionOfStudy,
          grade12CompletionYear: selectedYear,

          //!SUBJECTS SHOULD BE MANAGED LIKE CONTRIBUTIONS
          //!ONE SHOULD HAVE OT LOOP THE ARRAYS AND MAP TO CONRRESPONDING CONTROL
          subject1: data.subjects.length > 0 ? data.subjects[0] : "",
          subject2: data.subjects.length > 1 ? data.subjects[1] : "",
          subject3: data.subjects.length > 2 ? data.subjects[2] : "",
        });
        onProgressUpdate(progressIndicatorEnum.COMPLETED);
        setQualificationData(data);
        setYear(selectedYear.year());

      }
    } catch (error) {
      recordError(error);
    }
  }

  const getQualifications = async () => {
    try {
      const response = await lookupAPI.getQualifications();
      if (response) {
        const { data } = response;
        setQualifications(data);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const onQualificationChange = (selected) => {
    const qualificationSelected = qualifications.find(
      (record) => record.key == selected
    );
    form.setFieldsValue({ highestQualification: qualificationSelected });
  };

  const clearFormContents = () => {
    form.resetFields();
  };

  const disabledDates = (current) => {
    return current && current > dayjs().endOf("day");
  };
  const onSubmit = async (values) => {
    try {

      if(year === null || year === "" || year === undefined){
        openNotification("Save qualification", "Specify a year for Grade 12 completion", Notify.ERROR);
        return
      }
      const user = getProfile();

      const {
        highestQualification,
        fieldOfStudy,
        institutionOfStudy,
        subject1,
        subject2,
        subject3,
      } = values;

      const subjects = [subject1, subject2, subject3];
      const qualifications = {
        id: qualificationData?.id > 0 ? qualificationData.id : "-1",
        highestQualification: highestQualification.key,
        fieldOfStudy: fieldOfStudy,
        institutionOfStudy: institutionOfStudy,
        subjects: subjects,
        grade12CompletionYear: year,
        userId: user.userId,
      };

      onProgressUpdate(progressIndicatorEnum.IN_PROGRESS);

      const request = await api.addQualifications(qualifications);
      var msg;

      if (request && (request.status == 200 || request.status == 201)) {
        onProgressUpdate(progressIndicatorEnum.COMPLETED);
        msg = util.parseMessage(Messages.ADD_SUCCESS, "Qualification detail(s)");
        openNotification("Save qualification", msg, Notify.SUCCESS);
        return;
      }

      msg = util.parseMessage(Messages.ADD_FAILURE, "Qualification detail(s)");
      openNotification("Save qualification", msg, Notify.ERROR);


    } catch (error) {
      onProgressUpdate(progressIndicatorEnum.NOT_STARTED);
      openNotification("Adding qualification", "SYSTEM FAILED TO SAVE", Notify.ERROR);
      recordError(error);
    }
  };

  const onFinishFailed = (errorInfo) => {
    const namePath = errorInfo.errorFields[0].name;
    form.getFieldInstance(namePath)?.focus();
  };

  return (
    <>
      <h1 className="center-align">Highest Qualification</h1>
      <p className="sub-title center-align">Specify your highest qualification</p>
      <br />
      <Form
        {...formItemLayout}
        name={formName}
        form={form}
        onFinish={onSubmit}
        scrollToFirstError
        initialValues={{ remember: true }}
        onFinishFailed={onFinishFailed}
        labelCol={{
          span: 24,
        }}
      // disabled={readOnly}
      >
        <Row>
          <Col xs={24} sm={8} md={7}>
            <Form.Item
              name="highestQualification"
              label="Qualification"
              rules={[
                {
                  required: true,
                  message: "Please select your highest qualification",
                },
              ]}
            >
              <Select onChange={onQualificationChange} ref={highestQualificationRef}>
                {qualifications.map((qualification) => (
                  <Option key={qualification.key}>{qualification.value}</Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} sm={8} md={7}>
            <Form.Item
              name="fieldOfStudy"
              label="Field of Study"
              rules={[
                {
                  required: true,
                  message: "Please enter your field of study"
                },
                {
                  pattern: new RegExp("[A-Za-z]"),
                  message: "Provided charaters not allowed"
                }
              ]}
            >
              <Input name="fieldOfStudy" onBlur={onNameBlur} ref={fieldOfStudyRef} />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8} md={7}>
            <Form.Item
              name="institutionOfStudy"
              label="Institution of Study"
              rules={[
                {
                  required: true,
                  message: "Please enter your institution of study"
                },
                {
                  pattern: new RegExp("[A-Za-z]"),
                  message: "Provided charaters not allowed"
                }
              ]}
            >
              <Input name="institutionOfStudy" onBlur={onNameBlur} ref={institutionOfStudyRef} />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <p>Major Subjects (Max 3)</p>
        </Row>
        <Row>
          <Col xs={24} sm={8} md={7}>
            <Form.Item
              name="subject1"
              label="Subject 1"
              rules={[
                {
                  required: true,
                  message: "Please enter at least one subject",
                },
                {
                  pattern: new RegExp("[A-Za-z]"),
                  message: "Provided charaters not allowed"
                }
              ]}
            >
              <Input name="subject1" onBlur={onNameBlur} ref={subject1Ref} />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8} md={7}>
            <Form.Item
              name="subject2"
              label="Subject 2"
              rules={[
                {
                  pattern: new RegExp("[A-Za-z]"),
                  message: "Provided charaters not allowed"
                }
              ]}
            >
              <Input name="subject2" onBlur={onNameBlur} />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8} md={7}>
            <Form.Item
              name="subject3"
              label="Subject 3"
              rules={[
                {
                  pattern: new RegExp("[A-Za-z]"),
                  message: "Provided charaters not allowed"
                }
              ]}
            >
              <Input name="subject3" onBlur={onNameBlur} />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col xs={24} md={20}>
            <Form.Item
              name="grade12CompletionYear"
              label="Year Grade 12 obtained"
              rules={[
                {
                  required: true,
                  message: "Please select grade 12 completion year",
                },
              ]}
            >
              <DatePicker
                picker="year"
                disabledDate={disabledDates}
                ref={grade12CompletionYearRef}
                onChange={(value) => {
                  if (value) {
                    setYear(value.year());
                  }
                }}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row style={{paddingBottom:"15px",paddingRight:"15px"}}>
          <Col xs={24}>
            <Button key="2" htmlType="submit" form={formName} type="primary" shape="round" className="right-align-button">
              Save Highest Qualification
            </Button>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default Qualification;
